import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { modalClasses } from '../modal.classes';
import Box from '@mui/material/Box';
/**
 * The main content area of the Modal. Typically has `<ModalBody>`, `<ModalHeader>` and `<ModalFooter>` as children. Has to be placed within `<Modal>`.
 */ export const ModalContent = ({ styles, children })=>/*#__PURE__*/ _jsx(Box, {
        className: modalClasses.content,
        style: styles,
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
            overflow: 'hidden'
        },
        children: children
    });

//# sourceMappingURL=modalContent.js.map